// removed by extract-text-webpack-plugin
module.exports = {"PortfolioMini":"PortfolioMini","TabContent":"TabContent","tab-pane":"tab-pane","NavTab":"NavTab","PortfolioButton":"PortfolioButton","ag-header-row":"ag-header-row"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/Portfolio/PortfolioMini/styles.scss
// module id = 2023
// module chunks = 10